import Repository from "./Repository";

const resource = "/chatapi";
export default {
  getGuest() {
    return Repository.get(`${resource}/guest`);
  },
}
